module.exports = __webpack_public_path__ + "img/scorestar_gray.00011ef1.svg";